/** Цвета ролей: admin — красный, editor — жёлтый, reader — серый (прототип access). */
export function roleColors(role) {
    if (role === 'admin') {
        return { color: '#B91C1C', bg: '#FEF2F2', border: '#FECACA' };
    }
    if (role === 'editor') {
        return { color: '#B45309', bg: '#FFFBEB', border: '#FDE68A' };
    }
    return { color: '#475569', bg: '#F8FAFC', border: '#E2E8F0' };
}
export function roleSelectStyle(role, height, opts = {}) {
    const c = roleColors(role);
    const chevron = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" fill="none" stroke="${c.color}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`)}`;
    return {
        height,
        width: opts.width,
        flex: opts.flex ?? (height >= 38 ? 1 : 'none'),
        border: `1px solid ${c.border}`,
        borderRadius: 8,
        padding: '0 30px 0 12px',
        fontSize: height >= 38 ? 13 : 12.5,
        fontWeight: 600,
        background: `${c.bg} url("${chevron}") no-repeat right 11px center`,
        color: c.color,
        outline: 'none',
        cursor: opts.disabled ? 'not-allowed' : 'pointer',
        opacity: opts.disabled ? 0.85 : 1,
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none',
    };
}
export function roleBadgeStyle(role) {
    const c = roleColors(role);
    return {
        fontSize: 11,
        fontWeight: 600,
        padding: '3px 9px',
        borderRadius: 999,
        background: c.bg,
        color: c.color,
        border: `1px solid ${c.border}`,
    };
}
